<div class="container mx-auto px-4 py-6">
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-2xl font-bold">Actualizar Tipo de Mantenimiento</h1>
    <a routerLink="/maintenance-types" class="bg-transparent text-blue-600 border border-blue-600 hover:bg-blue-600 hover:text-white px-4 py-2 rounded-md">Volver</a>
  </div>
  <form [formGroup]="maintenanceTypeForm" (ngSubmit)="onSubmit()" class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
    <div class="mb-4">
      <label for="name" class="block text-sm font-bold mb-2">Nombre<span class="text-red-500">*</span>:</label>
      <input id="name" type="text" formControlName="name" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Nombre">
      <div *ngIf="name?.invalid && (name?.dirty || name?.touched)" class="text-red-500 text-sm">
        El nombre es obligatorio.
      </div>
    </div>
    <div class="mb-4">
      <label for="viewTypeId" class="block text-sm font-bold mb-2">Tipo de Vista<span class="text-red-500">*</span>:</label>
      <select id="viewTypeId" formControlName="viewTypeId" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
        <option value="" disabled>Seleccione un tipo de vista</option>
        <option *ngFor="let viewType of viewTypes" [value]="viewType.id">{{ viewType.name }}</option>
      </select>
      <div *ngIf="viewTypeId?.invalid && (viewTypeId?.dirty || viewTypeId?.touched)" class="text-red-500 text-sm">
        El tipo de vista es obligatorio.
      </div>
    </div>
    <div *ngIf="errorMessage" class="mb-4 text-red-500">
      {{ errorMessage }}
    </div>
    <div class="flex items-center justify-between">
      <button type="submit" class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
        Actualizar
      </button>
    </div>
  </form>
</div>
